
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Tagcategories',
    showminies:true,
    showmedia:false,
    vuexnamespace: 'tagcategories',
    initmutation:'tagcategories/TAGCATEGORY_INIT_TAGCATEGORY',
    backlink:'entities',
    duplicateable:true,
    helptext:"Hier werden die Tagkategorien also Sammelbegriffe für Tags eingegeben. Diese werden für die spätere Verwendung\n\
            zum Filtern der Datensätze oder zur optischen Aufbereitung der Darstellung von Rezeptkatalogen\n\
            benötigt<br><br> Der goldene Haken dient der Speicherung. Mit dem schwarzen Kreuz\n\
            wird ohne zu speichern das Formular verlassen. Mit dem Doppelhaken wird der Datensatz dupliziert."
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};